import React from 'react';
import { Modal } from './ui/Modal';
interface LegalModalsProps {
  termsOpen: boolean;
  privacyOpen: boolean;
  onCloseTerms: () => void;
  onClosePrivacy: () => void;
}
export function LegalModals({
  termsOpen,
  privacyOpen,
  onCloseTerms,
  onClosePrivacy
}: LegalModalsProps) {
  return <>
      {/* Términos y Condiciones */}
      <Modal isOpen={termsOpen} onClose={onCloseTerms} title="Términos y Condiciones" data-id="element-97">
        <div className="prose prose-invert prose-sm max-w-none" data-id="element-98">
          <p className="text-gray-300 mb-4" data-id="element-99">
            <strong className="text-[#D4AF37]" data-id="element-100">Última actualización:</strong>{' '}
            Enero 2025
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-101">
            1. Aceptación de los Términos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-102">
            Al acceder y utilizar Sistema Anticaos™, aceptas estar sujeto a
            estos términos y condiciones. Si no estás de acuerdo con alguna
            parte de estos términos, no podrás acceder al servicio.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-103">
            2. Descripción del Servicio
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-104">
            Sistema AntiCaos PRO™ es un programa digital de desarrollo personal
            que incluye:
          </p>
          <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2" data-id="element-105">
            <li data-id="element-106">Ebook Premium — Sistema AntiCaos PRO™</li>
            <li data-id="element-107">Bono 1: Meditaciones Guiadas (audio)</li>
            <li data-id="element-108">Bono 2: Workbook Interactivo (PDF)</li>
            <li data-id="element-109">Bono 3: Protocolo de 30 Días para no romper el sistema</li>
          </ul>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-110">
            3. Precio y Pago
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-111">
            El precio de lanzamiento del Sistema AntiCaos PRO™ es de $17 USD
            (pago único). El acceso es inmediato tras la confirmación del pago.
            Aceptamos las principales tarjetas de crédito y débito.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-112">
            4. Garantía de Devolución
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-113">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            satisfecho con el producto, puedes solicitar un reembolso completo
            dentro de los primeros 30 días desde la compra, sin preguntas ni
            condiciones adicionales.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-114">
            5. Propiedad Intelectual
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-115">
            Todo el contenido de Sistema Anticaos™ está protegido por derechos
            de autor. No está permitida la reproducción, distribución o reventa
            del material sin autorización expresa.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-116">
            6. Uso Personal
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-117">
            La licencia adquirida es para uso personal e intransferible. No está
            permitido compartir las credenciales de acceso ni el material con
            terceros.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-118">
            7. Limitación de Responsabilidad
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-119">
            Sistema Anticaos™ proporciona herramientas y recursos para el
            desarrollo personal. Los resultados pueden variar según el
            compromiso y dedicación de cada usuario. No garantizamos resultados
            específicos.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-120">
            8. Contacto
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-121">
            Para cualquier consulta sobre estos términos, puedes contactarnos a
            través de nuestros canales oficiales de soporte.
          </p>
        </div>
      </Modal>

      {/* Política de Privacidad */}
      <Modal isOpen={privacyOpen} onClose={onClosePrivacy} title="Política de Privacidad" data-id="element-122">
        <div className="prose prose-invert prose-sm max-w-none" data-id="element-123">
          <p className="text-gray-300 mb-4" data-id="element-124">
            <strong className="text-[#D4AF37]" data-id="element-125">Última actualización:</strong>{' '}
            Enero 2025
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-126">
            1. Información que Recopilamos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-127">
            Recopilamos la siguiente información cuando realizas una compra:
          </p>
          <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2" data-id="element-128">
            <li data-id="element-129">Nombre completo</li>
            <li data-id="element-130">Dirección de correo electrónico</li>
            <li data-id="element-131">
              Información de pago (procesada de forma segura por terceros)
            </li>
          </ul>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-132">
            2. Uso de la Información
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-133">Utilizamos tu información para:</p>
          <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2" data-id="element-134">
            <li data-id="element-135">Procesar tu compra y entregar el producto</li>
            <li data-id="element-136">Enviarte actualizaciones importantes sobre tu compra</li>
            <li data-id="element-137">Brindarte soporte al cliente</li>
            <li data-id="element-138">Mejorar nuestros productos y servicios</li>
          </ul>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-139">
            3. Protección de Datos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-140">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            alteración, divulgación o destrucción.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-141">
            4. Compartir Información
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-142">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros, excepto a proveedores de servicios de confianza que nos
            ayudan a operar nuestro negocio (procesadores de pago, servicios de
            email).
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-143">5. Cookies</h3>
          <p className="text-gray-300 mb-4" data-id="element-144">
            Utilizamos cookies para mejorar tu experiencia en nuestro sitio.
            Puedes configurar tu navegador para rechazar cookies, aunque esto
            puede afectar algunas funcionalidades.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-145">
            6. Tus Derechos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-146">Tienes derecho a:</p>
          <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2" data-id="element-147">
            <li data-id="element-148">Acceder a tu información personal</li>
            <li data-id="element-149">Rectificar datos inexactos</li>
            <li data-id="element-150">Solicitar la eliminación de tus datos</li>
            <li data-id="element-151">Oponerte al procesamiento de tus datos</li>
            <li data-id="element-152">Solicitar la portabilidad de tus datos</li>
          </ul>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-153">
            7. Retención de Datos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-154">
            Conservamos tu información personal mientras sea necesario para
            cumplir con los propósitos descritos en esta política, a menos que
            la ley requiera un período de retención más largo.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-155">
            8. Cambios en la Política
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-156">
            Nos reservamos el derecho de actualizar esta política de privacidad
            en cualquier momento. Te notificaremos sobre cambios significativos
            a través del correo electrónico registrado.
          </p>

          <h3 className="text-lg font-bold text-white mt-6 mb-3" data-id="element-157">
            9. Contacto
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-158">
            Si tienes preguntas sobre esta política de privacidad o deseas
            ejercer tus derechos, contáctanos a través de nuestros canales
            oficiales de soporte.
          </p>
        </div>
      </Modal>
    </>;
}